import { useProfile } from '@mint-lib/profile-helpers';
import { useQuery } from '@mint-lib/query-client';
import { MDMMetrics, type MetricsTypes } from '@mint-sdk/api-mdm';

export type MetricValueType = 'currency' | 'percent' | 'decimal';

export type GoalOptionType = {
  value: string;
  label: string;
  valueType: MetricValueType;
  decimalPlaces: number;
};

const adaptGroup = (
  metrics: MetricsTypes.GoalMetricType[] = [],
): GoalOptionType[] =>
  metrics.map((metric) => ({
    value: metric.urn,
    label: metric.name,
    valueType: metric.dataType as MetricValueType,
    decimalPlaces: Number(metric.dataTypeProperty?.decimalPlaces ?? 0),
  }));

const adaptGoalsOptions = (data: MetricsTypes.GoalMetricsOptionsDataType) => {
  const groups = data.items?.[0];

  return {
    overall: adaptGroup(groups?.standard),
    dataImportHub: adaptGroup(groups?.imported),
    adServer: adaptGroup(groups?.adServer),
    googleAnalytics: adaptGroup(groups?.analytics),
    platform: adaptGroup(groups?.platform),
  };
};

type UseGoalsOptionsApiParams = {
  enabled?: boolean;
  includeDisabled?: boolean;
};

export const useGoalsOptionsApi = ({
  enabled = true,
  includeDisabled = false,
}: UseGoalsOptionsApiParams = {}) => {
  const { getCompanyField } = useProfile();
  const companyId = getCompanyField('id');

  return useQuery({
    ...MDMMetrics.getGoalMetricsOptionsQuery({
      params: {
        companyId,
        includeDisabled,
      },
    }),
    select: adaptGoalsOptions,
    enabled,
  });
};
